exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n.complex-filter .complex-filter-display {\n  align-items: center;\n  display: flex;\n}\n.complex-filter .complex-filter-display .complex-filter-count {\n  padding-left: 8px;\n}\n.complex-filter mp-drop-menu {\n  left: initial;\n  margin-top: 10px;\n  top: initial;\n}\n", ""]);

// exports
